import { render, staticRenderFns } from "./detailAdd.vue?vue&type=template&id=03938c5b&"
import script from "./detailAdd.vue?vue&type=script&lang=js&"
export * from "./detailAdd.vue?vue&type=script&lang=js&"
import style0 from "./detailAdd.vue?vue&type=style&index=0&id=03938c5b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports